module.exports = __webpack_public_path__ + "images/ad71b0bd3bab6ecb91811599809e2b2d.svg";